import type { ComponentProps } from "react";

import { Button } from "@/components/ui/button";

export function Buttons({
  buttons,
}: {
  buttons: ComponentProps<typeof Button>[];
}) {
  return (
    <div className="flex gap-2 flex-wrap flex-row items-center">
      {buttons.map((button, index) => {
        return <Button variant="ghost" key={index} {...button} />;
      })}
    </div>
  );
}
